import {
  Lit3formBlock,
  html,
  unsafeHTML,
  classMap,
  icon,
} from '@Root/lib/lit-3form-block';
import { styles } from './css';

export class Dustin extends Lit3formBlock {
  static get characterName() {
    return 'dustin';
  }

  static get characterProperties() {
    return {
      _projectDetailsExpanded: { type: Boolean, state: true },
    };
  }

  static get characterStyles() {
    return [...styles];
  }

  constructor() {
    super();
    this._projectDetailsExpanded = false;
  }

  render() {
    return html`
      <div class="block-wrapper">
        <div class="block-grid dustin-layout">
          <div
            class=${classMap({
              'dustin-body': true,
              'project-details-hidden': this.hideProjectDetails,
            })}
          >
            <aside class="project-details">
              ${this.mobileProjectDetailsHTML} ${this.desktopProjectDetailsHTML}
            </aside>
            <div class="text-sections">
              ${this.textSectionsHTML}
            </div>
          </div>
          ${this.horizontalRule}
        </div>
      </div>
    `;
  }

  get textSectionsHTML() {
    if (!this.textSections.length) return html``;

    return html`
      ${this.textSections.map(
        section => html`
          <section class="text-section">
            ${section.heading
              ? html`
                  <h2 class="text-section-heading">
                    ${unsafeHTML(this.withLineBreaks(section.heading))}
                  </h2>
                `
              : html``}
            <div class="text-section-body">
              ${(section.paragraphs || []).map(
                paragraph => html`
                  <p class="text-section-paragraph">${unsafeHTML(paragraph)}</p>
                `
              )}
            </div>
          </section>
        `
      )}
    `;
  }

  get desktopProjectDetailsHTML() {
    if (this.hideProjectDetails || !this.projectDetails.length) return html``;

    return html`
      <div class="project-details-desktop">
        ${this.projectDetailRowsHTML}
      </div>
    `;
  }

  get mobileProjectDetailsHTML() {
    if (this.hideProjectDetails || !this.projectDetails.length) return html``;

    return html`
      <div
        class=${classMap({
          'project-details-mobile': true,
          expanded: this._projectDetailsExpanded,
          closed: !this._projectDetailsExpanded,
        })}
      >
        <div
          class="project-details-header"
          @click="${this.toggleProjectDetails}"
        >
          <span class="project-details-heading">PROJECT DETAILS</span>
          <span class="project-details-icon print-none">
            ${icon(this.toggleIcon)}
          </span>
        </div>
        <div class="project-details-content">
          ${this.projectDetailRowsHTML}
        </div>
      </div>
    `;
  }

  get projectDetailRowsHTML() {
    return html`
      ${this.projectDetails.map(
        row => html`
          <div class="project-detail-row">
            <p class="project-detail-label">
              ${unsafeHTML(this.withLineBreaks(row.header || ''))}
            </p>
            <div class="project-detail-value">
              ${unsafeHTML(row.text || '')}
            </div>
          </div>
        `
      )}
    `;
  }

  toggleProjectDetails() {
    this._projectDetailsExpanded = !this._projectDetailsExpanded;
  }

  get toggleIcon() {
    return this._projectDetailsExpanded ? 'minus' : 'plus';
  }

  get hideProjectDetails() {
    return this.content.hide_project_details == 1;
  }

  get projectDetails() {
    return this.content.project_details || [];
  }

  get textSections() {
    return this.content.text_sections || [];
  }
}
Dustin.defineElement();
